/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// ----------------------------------------------------------------------

export function flattenArray<T>(list: T[], key = 'children'): T[] {
  let children: T[] = [];

  const flatten = list?.map((item: any) => {
    if (item[key]?.length) {
      children = [...children, ...item[key]];
    }

    return item;
  });

  return flatten?.concat(
    children.length ? flattenArray(children, key) : children
  );
}
// EXPLICAÇÃO flattenArray
/* [
  1: {id: 1, name: oi},
  2: {id: 2, name: oi},
  3: {id: 3, name: oi},
  4: {id: 4, name: oi, children: [
    5: {id: 5, name: oi},
    6: {id: 6, name: oi},
  ],
  7: {id: 7, name: oi},
]

   1 vez -
    children = [
      4: {id: 4, name: oi},
      5: {id: 5, name: oi},
      6: {id: 6, name: oi},
    ]
    flatten = [
      1: {id: 1, name: oi},
      2: {id: 2, name: oi},
      3: {id: 3, name: oi},
      7: {id: 7, name: oi},
    ]

    flatten?.concat(true ? flattenArray([
      4: {id: 4, name: oi},
      5: {id: 5, name: oi},
      6: {id: 6, name: oi},
    ], 'children') : children);

    2a vez -

    children = []
    flatten = [
      { id: 1, name: 'oi' },
      { id: 2, name: 'oi' },
      { id: 3, name: 'oi' },
      { id: 4, name: 'oi' },
      { id: 5, name: 'oi' },
      { id: 6, name: 'oi' },
      { id: 7, name: 'oi' },
    ]
    flatten?.concat(false ? flattenArray([], 'children') : []);
  */
